import React from 'react';
import { useEqualisationSection } from './EqualisationContext';
import { Button, CircularProgress, Tooltip, Typography } from '@mui/material';
import { round } from 'lodash';
import { Row } from 'further-ui/components/Layout';

interface EqualisationFooterProps {
  handleNext?: () => void;
  handlePrevious?: () => void;
  handleSaveAsDraft?: () => void;
  customPrevious?: React.ReactNode;
  customNext?: React.ReactNode;
  hideCompletionPercentage?: boolean;
  disabled?: boolean;
  loading: boolean;
  tooltipDisabledMessage?: string;
}

const EqualisationFooter: React.FC<EqualisationFooterProps> = ({
  handleNext,
  handlePrevious,
  handleSaveAsDraft,
  customNext,
  customPrevious,
  disabled,
  loading,
  tooltipDisabledMessage,
  hideCompletionPercentage = false,
}) => {
  const { previousSection, sections, currentSection } =
    useEqualisationSection();

  const percentageOfSections = round(
    (sections.indexOf(currentSection) / sections.length) * 100,
    2,
  );

  return (
    <Row centered fullWidth justify="space-between">
      <Row spacing="md">
        {customPrevious ? (
          customPrevious
        ) : previousSection ? (
          <Button
            size="large"
            variant="outlined"
            onClick={handlePrevious}
            loading={loading}
          >
            Back
          </Button>
        ) : (
          <div />
        )}
        {handleSaveAsDraft ? (
          <Button
            size="large"
            loading={loading}
            onClick={handleSaveAsDraft}
            variant="outlined"
          >
            Save as draft
          </Button>
        ) : null}
      </Row>

      <Row centered spacing="sm">
        {customNext ? (
          customNext
        ) : (
          <Tooltip
            title={
              disabled
                ? tooltipDisabledMessage ??
                  'Please ensure that the total expense in the allocation equals the action amount.'
                : undefined
            }
          >
            <span>
              <Button
                size="large"
                component="button"
                onClick={handleNext}
                loading={loading}
                disabled={disabled}
                variant="contained"
              >
                Approve & next
              </Button>
            </span>
          </Tooltip>
        )}
        {hideCompletionPercentage ? null : (
          <Row spacing="xs" centered>
            <Typography variant="h6" color="text.secondary">
              {percentageOfSections}%
            </Typography>
            <CircularProgress
              variant="determinate"
              value={percentageOfSections}
              size={24}
            />
          </Row>
        )}
      </Row>
    </Row>
  );
};

export default EqualisationFooter;
